import React from 'react';
import ResourceAccess from '../../../../components/permissions/ResourceAccess';

export default function TransactionAccess({ transaction }) {
  return (
    <div className="space-y-6">
      <ResourceAccess resourceType="TRANSACTION" resourceId={transaction.id} />
    </div>
  );
}
